<div class="d-flex flex-column">
    <div class="h3 m-2">Promo Codes</div>
    <div  *ngIf="promoCodeSelected" class="card mb-4">
        <app-promo-code-record-view [(promoCodeSelected)]="promoCodeSelected"></app-promo-code-record-view>
    </div>
    <div class="card"> 
        <app-promo-code-list-view [(promoCodeSelected)]="promoCodeSelected"></app-promo-code-list-view>
    </div>
</div>



    